<template>
  <div style="height: 100vh;">
    <el-carousel trigger="click" :autoplay="true" arrow="never"  height="100vh" ref="carousel">
      <el-carousel-item v-for="(item, index) in backgroundImages" :key="index">
        <div :style="{ height: '100vh', backgroundImage: `url(${item})` }" class="main">
          <slot name="page">
            <div :class="{ moveUp: true }">
              <div class="slogan">
                <h1 style="display: block;width: 100vw">Hengchuang Wenn wir sie mit unseren produkten und diensten verbinden

                </h1>
              </div>
            </div>
            <i style="font-style: normal;color: red;font-size: 2rem;position: absolute;bottom: 30px;right: 40px;font-weight: bolder" >{{picName[index]}}</i>

          </slot>
        </div>

      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {
      isPC: true,
      backgroundImages: [
        require("../../assets/about.jpg"),
        require("../../assets/098a59b0debe61629d87fc2a1f76cde.jpg"),
        require("../../assets/a08228f4cd4f584c34865bf633a3c8b.jpg"),
        require("../../assets/fcf60d1e0b3de2da20aa673e2329793.jpg"),
        // 添加更多背景图片路径
      ],
      picName:[
         "Renderings der Nanjing Hengchuang Magnetoelectric Co., Ltd.",
         "Echtaufnahmen der Fabrik in Luhe der Nanjing Hengchuang Magnetoelectric Co., Ltd.",
         "Renderings der Tianchang Hengchuang Magnetoelectric Co., Ltd.",
         "Renderings des Laborgebäudes der Tianchang Hengchuang Magnetoelectric Co., Ltd."
      ]
    };
  },
  created() {
    if (this._isMobile()) {
      if (this._isMobile().indexOf("iPad") != -1) {
        this.isPC = true;
      } else {
        this.isPC = false;
      }
    } else {
      this.isPC = true;
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    }
  }
};
</script>

<style scoped>
.slogan {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 888;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  font-size: 1.8rem;
  color: white;
}

.main {
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #cccccc;
  position: relative;
}

/* 自定义指示器样式 */



</style>
